module.exports = __webpack_public_path__ + "img/as.as6fde2eb.svg";